import { useQuery } from "@tanstack/react-query";
import { getStoreAccessToken } from "../../utils/auth";
import { fetcher } from "../../utils/fetchers";
import { Ticket } from "../../types/modules/ticket.type";

interface UseParams {
  page?: number;
  limit?: number;
  status?: string;
}

export const useStoretickets = ({
  page = 1,
  limit = 10,
  status = "",
}: UseParams) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    status: status?.toString(),
  });

  const token = getStoreAccessToken();

  return useQuery({
    queryKey: ["store-tickets", page, limit, status, token],
    queryFn: () =>
      fetcher<{ data: Ticket[]; totalPages: number; totalItems: number }>(
        `ticket?${queryParams.toString()}`,
        token
      ),
  });
};
